// Radha — UPI payment deep links (Zoho Checkout style, no gateway account). The
// UPI spec defines a plain `upi://pay?...` URI that any UPI app (GPay, PhonePe,
// Paytm, BHIM, ...) opens directly for the receiving VPA — no merchant account,
// API key, or payment gateway integration required. This is the honest zero-setup
// payment path; a real gateway (Razorpay/Cashfree) needs the tenant's own
// credentials, which this session cannot obtain.
export function upiPayLink(vpa: string, payeeName: string, amount: number, note: string): string {
  const params = new URLSearchParams({
    pa: vpa, pn: payeeName, am: amount.toFixed(2), cu: "INR", tn: note.slice(0, 50),
  });
  return `upi://pay?${params.toString()}`;
}
